var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowitworkstep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4453_52424)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#EBEEF4"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4453_52424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9912 12.6718L27.4912 5.25049L17.9912 12.6718H20.7726V49.2505H34.2098V12.6718H36.9912Z",
    fill: "#41CE8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3008 49.1975V36.1981L18.4818 21.8165L36.4116 23.7586L43.8839 27.8683V46.9195L36.7107 47.5162L36.6371 50.5045L23.7497 51.9986L10.3008 49.1975Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7627 38.0029V40.4825L39.4021 40.3481C39.4021 40.3481 39.3845 45.1937 39.3205 47.4077L44.3628 46.9214V37.8813L35.7627 38.0029ZM43.355 43.0357L40.6659 43.2596L40.6451 39.5659L43.355 39.4315V43.0357Z",
    fill: "#5E6473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8917 35.0415L47.104 37.2827V38.2537L36.501 38.3833L36.5698 34.8927L43.8917 35.0415Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8154 27.1954V35.0405H43.8845V27.8689L35.8154 27.197V27.1954ZM42.8382 33.3704H38.207V28.8672L42.8382 29.2527V33.3704Z",
    fill: "#5E6473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8154 21.4432V18.0822L18.6377 17.4103L18.5625 20.9217L17.8154 21.4432Z",
    fill: "#D3D9E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.748 25.8888V51.9996L25.6805 51.7756L25.8773 42.1388L34.1703 41.8397L33.9671 50.907L36.6355 50.507L36.7842 26.8982L23.748 25.8904V25.8888ZM32.7497 36.6102L27.0467 36.6646L27.1475 28.6915L32.8249 29.0275L32.7497 36.6102Z",
    fill: "#A3ABBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04883 38.7779H11.4193L22.6638 21.4448L16.6856 20.8481L7.04883 38.7779Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 17.4103H19.9727V21.5184L18.5537 21.3696L18.6289 17.4103Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3008 49.1975V36.1981L18.4818 21.8165L23.7497 25.8878V51.9986L10.3008 49.1975Z",
    fill: "#D3D9E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6816 20.8465L24.1892 26.5624L45.3696 28.3925V27.6086L36.1807 22.7534C36.1807 22.7534 16.6816 20.7346 16.6816 20.8465Z",
    fill: "#0C625E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4453_52424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4453_52424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.7925,
    height: 54,
    fill: "white",
    transform: "translate(3.99902 -1.99939)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowitworkstep3);
export default __webpack_public_path__ + "static/media/howitworkstep3.2918f0df2aee6caefa0fcbe582fbdf99.svg";
export { ForwardRef as ReactComponent };